<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="search row"></div>
      <div class="row">
        <div class="col">
          <div class="card shadow bg-secondary">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
                    กรุณากรอกข้อมูล
                  </h3>
                </div>
                <div class="col text-right">
                  <base-button type="primary" size="sm" @click="saveReceipts"
                    >บันทึก</base-button
                  >
                </div>
              </div>
            </div>

            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col-md-6 col-12">
                  <base-input
                    alternative=""
                    label="ชื่อ-สกุล"
                    placeholder="ชื่อ-สกุล"
                    input-classes="form-control-alternative"
                    v-model="formData.name"
                  />
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="เบอร์โทรศัพท์"
                    placeholder="เบอร์โทรศัพท์"
                    type="tel"
                    maxLength="10"
                    input-classes="form-control-alternative"
                    v-model="formData.tel"
                  />
                </div>
                <div class="col-md-2 col-12">
                  <label for="total" class="form-control-label"
                    >ยอดเรียกเก็บ</label
                  >
                  <h4 class="heading-small text-muted mt-2">
                    {{ isLoaded ? Number(calculateTotal).toLocaleString() : 0 }}
                  </h4>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="ยอดจ่ายจริง"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="formData.real_price"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <base-checkbox class="mt-2" v-model="formData.is_installment">
                    ลูกค้าผ่อน
                  </base-checkbox>
                </div>
              </div>
              <div
                class="row mt-4"
                :class="!formData.is_installment ? 'none' : ''"
              >
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 1"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="formData.installment_1_price"
                    :disabled="!!formData.paid_1"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="formData.paid_1">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 2"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="formData.installment_2_price"
                    :disabled="!!formData.paid_2"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="formData.paid_2">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-2 col-12">
                  <base-input
                    alternative=""
                    label="งวดที่ 3"
                    placeholder="จำนวนเงิน"
                    type="number"
                    step="any"
                    input-classes="form-control-alternative"
                    v-model="formData.installment_3_price"
                    :disabled="!!formData.paid_3"
                  />
                </div>
                <div class="col-md-1 col-12">
                  <base-checkbox class="mt-md-5 mt-0" v-model="formData.paid_3">
                    จ่ายแล้ว
                  </base-checkbox>
                </div>
                <div class="col-md-3 col-12">
                  <label for="total" class="form-control-label"
                    >ยอดผ่อนรวม 3 งวด</label
                  >
                  <h4 class="heading-small text-muted mt-2">
                    {{
                      calculateInstallment
                        ? Number(calculateInstallment).toLocaleString()
                        : 0
                    }}
                  </h4>
                </div>
              </div>
              <!-- Car 1 -->
              <div class="col car" v-for="x in models.length" :key="x">
                <hr />
                <h1>คันที่ {{ x }}</h1>
                <div class="row mx-2 mb-3 mt-md-2 mt-3">
                  <base-radio name="car" v-model="car_type[x]">
                    รถยนต์
                  </base-radio>

                  <base-radio
                    name="motorcycle"
                    class="ml-4"
                    v-model="car_type[x]"
                  >
                    มอเตอร์ไซต์
                  </base-radio>
                </div>
                <div class="row">
                  <div class="col-md-6 mt-2">
                    <h4>ประเภทของเบี้ยประกัน</h4>
                    <div class="dropdown">
                      <b-dropdown
                        id="dropdown"
                        offset="100"
                        class="m-0 mr-2"
                        :text="insurance_type_name[x]"
                      >
                        <b-dropdown-item
                          v-for="insuranceType in masterInsuranceType"
                          :key="insuranceType.id"
                          :value="insuranceType.name"
                          @click="
                            selectInsuranceType(
                              x,
                              insuranceType.id,
                              insuranceType.name
                            )
                          "
                          >{{ insuranceType.name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <div class="col-md-2 mt-2 mt-md-0">
                    <h4>บริษัท</h4>
                    <div class="dropdown">
                      <b-dropdown
                        id="dropdown"
                        offset="100"
                        class="m-0 mr-2"
                        :text="insurance_company_fullname[x]"
                      >
                        <b-dropdown-item
                          v-for="insuranceCompany in masterInsuranceCompany"
                          :key="insuranceCompany.id"
                          :value="insuranceCompany.name"
                          @click="
                            selectInsuranceCompany(
                              x,
                              insuranceCompany.id,
                              insuranceCompany.name,
                              insuranceCompany.fullname
                            )
                          "
                          >{{ insuranceCompany.fullname }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                  <div class="col-md-4 mt-2 mt-md-0">
                    <base-input
                      alternative=""
                      label="บริษัทประกันอื่นๆ"
                      placeholder="ถ้ามี"
                      :disabled="insurance_company_name[x] !== 'OTHER'"
                      input-classes="form-control-alternative"
                      v-model="if_other_insurance_company[x]"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <h4>ยี่ห้อรถ</h4>
                    <div class="dropdown">
                      <b-dropdown
                        id="dropdown"
                        offset="100"
                        class="m-0 mr-2"
                        :text="brand_name[x]"
                      >
                        <b-dropdown-item
                          v-for="brand in masterBrand"
                          :key="brand.id"
                          :value="brand.name"
                          @click="selectBrand(x, brand.id, brand.name)"
                          >{{ brand.name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-2">
                    <base-input
                      alternative=""
                      label="เลขทะเบียน"
                      placeholder="เลขทะเบียน"
                      input-classes="form-control-alternative"
                      v-model="license_plate[x]"
                    />
                  </div>
                  <div class="col-md-4">
                    <h4>จังหวัด</h4>
                    <v-select
                      v-model="license_plate_province[x]"
                      :options="masterProvince"
                      :reduce="(p) => p.id"
                      label="name"
                    ></v-select>
                    <!-- <div class="dropdown">
                      <b-dropdown
                        id="dropdown"
                        offset="100"
                        :text="
                          selectedLicensePlateProvince[x] !== -1
                            ? masterProvince[selectedLicensePlateProvince[x]]
                                .name
                            : '-- กรุณาเลือก --'
                        "
                        class="m-0 mr-2"
                      >
                        <b-dropdown-item
                          v-for="(province, index) in masterProvince"
                          :key="province.id"
                          :value="province.name"
                          @click="
                            selectLicensePlateProvince(x, province.id, index)
                          "
                          >{{ province.name }}</b-dropdown-item
                        >
                      </b-dropdown>
                    </div> -->
                  </div>
                  <div class="col-md-6">
                    <base-input
                      alternative=""
                      label="จำนวนเงินประกัน"
                      type="number"
                      step="any"
                      placeholder="จำนวนเงินประกัน"
                      input-classes="form-control-alternative"
                      v-model="insurance_price[x]"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <base-input
                      alternative=""
                      label="จำนวนเงิน พรบ."
                      type="number"
                      step="any"
                      placeholder="จำนวนเงิน พรบ."
                      input-classes="form-control-alternative"
                      v-model="wsu_price[x]"
                    />
                  </div>
                  <div class="col-md-4">
                    <base-input
                      alternative=""
                      label="จำนวนเงินต่อภาษี"
                      type="number"
                      step="any"
                      placeholder="จำนวนเงินต่อภาษี"
                      input-classes="form-control-alternative"
                      v-model="tax_price[x]"
                    />
                  </div>
                  <div class="col-md-2">
                    <base-checkbox
                      class="mt-md-5 mt-0"
                      v-model="is_inspected[x]"
                    >
                      ตรวจสภาพ
                    </base-checkbox>
                  </div>
                </div>
                <h6 class="heading-small text-muted mt-4 mt-md-2">
                  อื่นๆ
                </h6>
                <div class="row">
                  <div class="col-md-3">
                    <base-input
                      alternative=""
                      label="รายการ"
                      placeholder="รายการ"
                      input-classes="form-control-alternative"
                      v-model="other[x]"
                    />
                  </div>
                  <div class="col-md-3">
                    <base-input
                      alternative=""
                      label="จำนวนเงิน"
                      placeholder="จำนวนเงิน"
                      type="number"
                      step="any"
                      input-classes="form-control-alternative"
                      v-model="other_price[x]"
                      :disabled="other[x] === ''"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import router from "../router";
import Dropdown from "bootstrap-vue/src/components/dropdown";
import axios from "axios";
import kickMixin from "../mixins/kickMixin";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);
Vue.use(Dropdown);

export default {
  name: "receiptGroupDetail",
  mixins: [kickMixin],
  props: {
    type: {
      type: String,
    },
  },
  data() {
    return {
      row: 10,
      isLoaded: false,
      masterInsuranceType: [],
      masterInsuranceCompany: [],
      masterBrand: [],
      masterProvince: [],
      selectedLicensePlateProvince: [],
      formData: {
        name: "",
        tel: "",
        is_installment: false,
        installment_1_price: "",
        installment_2_price: "",
        installment_3_price: "",
        paid_1: false,
        paid_2: false,
        paid_3: false,
        real_price: "",
        created_by: -1,
        created_by_name: "",
      },

      models: [],
      newModels: [],

      car_type: [],
      id: [],
      insurance_type: [],
      insurance_type_name: [],
      insurance_company: [],
      insurance_company_name: [],
      insurance_company_fullname: [],
      brand: [],
      brand_name: [],
      if_other_insurance_company: [],
      license_plate: [],
      license_plate_province: [],
      wsu_price: [],
      insurance_price: [],
      tax_price: [],
      is_inspected: [],
      other: [],
      other_price: [],
    };
  },
  computed: {
    calculateTotal() {
      let inspect_price = 0;
      for (let j = 1; j <= this.row; j++) {
        if (this.is_inspected[j] && this.car_type[j] === "car") {
          inspect_price += 200;
        } else if (this.is_inspected[j] && this.car_type[j] === "motorcycle") {
          inspect_price += 60;
        }
      }

      let sumOfInsurance = this.insurance_price.reduce(
        (acc, item) => Number(acc) + Number(item),
        0
      );
      let sumOfWSU = this.wsu_price.reduce(
        (acc, item) => Number(acc) + Number(item),
        0
      );
      let sumOfTax = this.tax_price.reduce(
        (acc, item) => Number(acc) + Number(item),
        0
      );
      let sumOfOther = this.other_price.reduce(
        (acc, item) => Number(acc) + Number(item),
        0
      );
      return sumOfInsurance + sumOfWSU + sumOfTax + sumOfOther + inspect_price;
    },
    calculateInstallment() {
      return (
        Number(this.formData.installment_1_price) +
        Number(this.formData.installment_2_price) +
        Number(this.formData.installment_3_price)
      );
    },
  },
  methods: {
    loadReceipt: function() {
      var localApp = this;
      axios
        .get(
          "https://api.sd5525.com/api/receiptGroup/" + this.$route.params.id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.models = response.data.data;
          localApp.formData.name = response.data.data[0].name;
          localApp.formData.tel = response.data.data[0].tel;
          localApp.formData.is_installment =
            response.data.data[0].is_installment;
          localApp.formData.installment_1_price =
            response.data.data[0].installment_1_price;
          localApp.formData.installment_2_price =
            response.data.data[0].installment_2_price;
          localApp.formData.installment_3_price =
            response.data.data[0].installment_3_price;
          localApp.formData.paid_1 = response.data.data[0].paid_1;
          localApp.formData.paid_2 = response.data.data[0].paid_2;
          localApp.formData.paid_3 = response.data.data[0].paid_3;
          localApp.formData.real_price = response.data.data[0].real_price;

          for (let i = 1; i <= localApp.models.length; i++) {
            localApp.car_type[i] = response.data.data[i - 1].car_type;
            localApp.id[i] = response.data.data[i - 1].id;
            localApp.insurance_type[i] =
              response.data.data[i - 1].insurance_type;
            localApp.insurance_type_name[i] =
              response.data.data[i - 1].insurance_type_name;

            localApp.insurance_company[i] =
              response.data.data[i - 1].insurance_company;
            localApp.insurance_company_name[i] =
              response.data.data[i - 1].insurance_company_name;
            localApp.insurance_company_fullname[i] =
              response.data.data[i - 1].insurance_company_fullname;

            localApp.brand[i] = response.data.data[i - 1].brand;
            localApp.brand_name[i] = response.data.data[i - 1].brand_name;

            localApp.if_other_insurance_company[i] =
              response.data.data[i - 1].if_other_insurance_company;
            localApp.license_plate[i] = response.data.data[i - 1].license_plate;
            localApp.license_plate_province[i] =
              response.data.data[i - 1].license_plate_province;

            localApp.selectedLicensePlateProvince[
              i
            ] = localApp.masterProvince.findIndex(
              (item) => item.id === localApp.license_plate_province[i]
            );

            localApp.insurance_price[i] =
              response.data.data[i - 1].insurance_price;
            localApp.wsu_price[i] = response.data.data[i - 1].wsu_price;
            localApp.tax_price[i] = response.data.data[i - 1].tax_price;
            localApp.is_inspected[i] = !!parseInt(
              response.data.data[i - 1].is_inspected
            );
            localApp.other[i] = response.data.data[i - 1].other;
            localApp.other_price[i] = response.data.data[i - 1].other_price;
          }

          localApp.isLoaded = true;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    saveReceipts: function() {
      var localApp = this;
      if (
        localApp.license_plate.length !== 0 &&
        localApp.formData.name !== "" &&
        localApp.formData.tel !== ""
      ) {
        localApp.license_plate.forEach(function(entry, index) {
          let obj = {};
          obj["id"] = localApp.id[index];
          obj["name"] = localApp.formData.name;
          obj["tel"] = localApp.formData.tel;
          obj["is_installment"] = localApp.formData.is_installment;
          obj["installment_1_price"] = localApp.formData.installment_1_price;
          obj["installment_2_price"] = localApp.formData.installment_2_price;
          obj["installment_3_price"] = localApp.formData.installment_3_price;
          obj["paid_1"] = localApp.formData.paid_1;
          obj["paid_2"] = localApp.formData.paid_2;
          obj["paid_3"] = localApp.formData.paid_3;
          obj["real_price"] = localApp.formData.real_price;
          obj["car_type"] = localApp.car_type[index];
          obj["insurance_type"] = localApp.insurance_type[index];
          obj["insurance_type_name"] = localApp.insurance_type_name[index];
          obj["insurance_company"] = localApp.insurance_company[index];
          obj["insurance_company_name"] =
            localApp.insurance_company_name[index];
          obj["insurance_company_fullname"] =
            localApp.insurance_company_fullname[index];
          obj["if_other_insurance_company"] =
            localApp.if_other_insurance_company[index];
          obj["brand"] = localApp.brand[index];
          obj["brand_name"] = localApp.brand_name[index];
          obj["license_plate"] = entry;
          obj["license_plate_province"] =
            localApp.license_plate_province[index];
          obj["insurance_price"] = localApp.insurance_price[index];
          obj["wsu_price"] = localApp.wsu_price[index];
          obj["tax_price"] = localApp.tax_price[index];
          obj["is_inspected"] = localApp.is_inspected[index];
          obj["other"] = localApp.other[index];
          obj["other_price"] = localApp.other_price[index];

          localApp.newModels.push(obj);
        });

        axios
          .patch(
            "https://api.sd5525.com/api/receiptGroup/" + this.$route.params.id,
            localApp.newModels,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then(function(response) {
            if (response.status == 200) {
              router.push("/receipt");
            }
          })
          .catch(function(error) {
            alert(error);
          });
      } else {
        alert("ใส่ชื่อ เบอร์โทร และข้อมูลอย่างน้อย 1 คัน");
      }
    },
    getInsuranceType: function() {
      var localApp = this;
      axios
        .get("https://api.sd5525.com/api/master/insuranceType", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterInsuranceType = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getInsuranceTCompany: function() {
      var localApp = this;
      axios
        .get("https://api.sd5525.com/api/master/insuranceCompany", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterInsuranceCompany = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getBrand: function() {
      var localApp = this;
      axios
        .get("https://api.sd5525.com/api/master/brand", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterBrand = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    getProvince: function() {
      var localApp = this;
      axios
        .get("https://api.sd5525.com/api/master/province", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            localApp.masterProvince = response.data.data;
          }
        })
        .catch(function() {
          localApp.kick();
        });
    },
    selectInsuranceType: function(index, id, name) {
      var localApp = this;

      localApp.insurance_type_name[index] = name;
      localApp.insurance_type[index] = id;
      localApp.$forceUpdate();
    },
    selectInsuranceCompany: function(index, id, name, fullname) {
      var localApp = this;

      localApp.insurance_company[index] = id;
      localApp.insurance_company_name[index] = name;
      localApp.insurance_company_fullname[index] = fullname;

      localApp.$forceUpdate();
    },
    selectBrand: function(index, id, name) {
      var localApp = this;

      localApp.brand[index] = id;
      localApp.brand_name[index] = name;

      localApp.$forceUpdate();
    },
    selectLicensePlateProvince: function(index, id, idx) {
      var localApp = this;

      localApp.selectedLicensePlateProvince[index] = idx;
      localApp.license_plate_province[index] = id;

      localApp.$forceUpdate();
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.getInsuranceType();
      this.getInsuranceTCompany();
      this.getBrand();
      this.getProvince();

      this.loadReceipt();
    }
  },
};
</script>
<style>
h4 {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}

.dropdown-menu {
  max-height: 300px !important;
  overflow-y: auto;
}
</style>
